import {
	OverdistributionErrorSourceEnum,
	PersonGroupSummary,
} from '@dealstack/shared/lib/generated';
import { SetRequired } from 'type-fest';

export type ValuationsValidationError = {
	personId: string;
	mipId: string | null;
	sourceType: OverdistributionErrorSourceEnum;
	title: string;
	description: string;
	overrideTier?: number;
};

export function personGroupHasErrors(
	group: PersonGroupSummary
): group is SetRequired<PersonGroupSummary, 'error'> {
	return !!group.error;
}
